import styled from "styled-components";

export const Container = styled.main`
	min-height: calc(var(--main-height) + 25px);
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 50px;

	.loadmore-button_wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		button {
			cursor: pointer;
			padding: 10px 40px;
			border-radius: 8px;
			background-color: var(--main-green);
			border: solid 2px var(--light-green);
			color: white;
			transition: 600ms ease;
		}
		button:hover {
			background-color: #09492e;
			border-color: var(--main-green);
		}
	}

	.title-wrapper {
		max-width: 1900px;
		margin: 0 auto;
		text-align: left;
		justify-self: start;
		width: 100%;

		h1 {
			max-width: max-content;
			font-size: 34px;

			border-bottom: 3px solid var(--main-green);
			padding-right: 50px;
			padding-bottom: 5px;
		}
	}

	.notice_list-wrapper {
		max-width: 1900px;
		margin: 0 auto;
		ul {
			display: flex;
			justify-content: center;
			flex-flow: row wrap;
			gap: 20px;
		}
	}
`;
